<script setup lang="ts">
import type { Component } from "vue";
import { RouterLink } from "vue-router";

/**
 * Пункт бічної навігації app-shell (widget-локальний, не DS-примітив).
 * Active-стан бере з RouterLink (`custom` slot): головний `/` — за точним
 * збігом (`exact`), інші — за префіксним `isActive`. Active → `aria-current=page`.
 */
defineProps<{
  to: string;
  label: string;
  icon: Component;
  exact?: boolean;
}>();
</script>

<template>
  <RouterLink
    v-slot="{ href, navigate, isActive, isExactActive }"
    :to="to"
    custom
  >
    <a
      :href="href"
      data-slot="nav-item"
      :aria-current="(exact ? isExactActive : isActive) ? 'page' : undefined"
      :class="[
        'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium outline-none transition-colors',
        'focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        (exact ? isExactActive : isActive)
          ? 'bg-primary/10 text-primary font-medium'
          : 'text-muted-foreground hover:bg-accent/50 hover:text-foreground',
      ]"
      @click="navigate"
    >
      <component
        :is="icon"
        class="size-4 shrink-0"
        aria-hidden="true"
      />
      <span>{{ label }}</span>
    </a>
  </RouterLink>
</template>
